import { Routes } from '@angular/router';
import { HomeComponent } from '@educare/shared';
import { authGuard } from './core/guards/auth.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'face-verification',
    loadComponent: () =>
      import('./features/face-verification/face-verification.component').then((m) => m.FaceVerificationComponent),
    canActivate: [authGuard]
  },
  {
    path: '',
    component: HomeComponent,
    loadChildren: () => import('./features/features.routes').then((m) => m.FEATURE_ROUTES),
    canActivate: [authGuard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then((m) => m.AUTH_ROUTES)
  },
  {
    path: 'refresh',
    component: HomeComponent
  },
  { path: '', redirectTo: '/', pathMatch: 'full' },
  { path: '**', redirectTo: '/' }
];
